<!-- <div class="adc-tag-basic" *ngIf="type == 'basic'" ngClass="{{ data.customClass }}">
    <label>{{data.label}}</label>
</div>

<div class="adc-tag-icon-left" *ngIf="type == 'iconLeft'" ngClass="{{ data.customClass }}">
    <mat-icon>{{data.icon}}</mat-icon>
    <label>{{data.label}}</label>
</div>

<div class="adc-tag-icon-right" *ngIf="type == 'iconRight'" ngClass="{{ data.customClass }}">
    <label>{{data.label}}</label>
    <mat-icon>{{data.icon}}</mat-icon>
</div>

<div class="adc-tag-img-left" *ngIf="type == 'imageLeft'" ngClass="{{ data.customClass }}">
    <img src="{{data.image}}" alt="">
    <label>{{data.label}}</label>
</div> -->